// auth-image-url.pipe.ts
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { ImageCacheService } from 'src/app/core/services/cache/image-cache.service';

@Pipe({
  name: 'authImageUrl',
  standalone: true,
})
export class AuthImageUrlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly imageCache = inject(ImageCacheService);
  private readonly placeholder = this.sanitizer.bypassSecurityTrustUrl('assets/images/placeholder-learner.webp');

  transform(imageUrl: string | SafeUrl | undefined): Observable<SafeUrl | undefined> {
    if (!imageUrl) {
      return of(this.placeholder);
    }

    if (typeof imageUrl !== 'string') {
      return of(imageUrl);
    }

    const cleanedUrl = imageUrl.replace(/^unsafe:/, '').trim();

    if (!cleanedUrl) {
      return of(this.placeholder);
    }

    if (!cleanedUrl.includes('/ds-msal')) {
      return of(this.sanitizer.bypassSecurityTrustUrl(cleanedUrl));
    }

    return this.imageCache.get(cleanedUrl, true);
  }
}
